import PropTypes from "prop-types";
import submit from "submit-form";
import Modal from "../../../../parts/modal-new";

const EnablePullCommunityChatModal = ({ locals: _locals }) => {

  const handleConfirm = (e) => {
    e.preventDefault();
    submit("/actions/community-chat/enable-pull-community-chat", {
      method: "POST",
      body: {},
    });
  };

  const handleCancel = () => {
    submit("/actions/refresh/?", {
      method: "GET",
      body: { "modal[type]": "" },
    });
  };

  return (
    <Modal className={"enable-pull-community-chat-modal"} title={"Enable Community Chat"}>
      <div className="body">
        <p className="opacity-70 text-[0.875rem]">
          Community Chat lets you create channels where all your clients can
          participate in group discussions. This is different from the existing
          1:1 chat and group chats, which are private conversations between you
          and individual clients or small groups.
        </p>
      </div>

      <footer className="flex justify-end! gap-2">
        <button data-button-type="secondary" onClick={handleCancel}>
          Cancel
        </button>
        <button data-button-type="primary" onClick={handleConfirm}>
          Enable Community Chat
        </button>
      </footer>
    </Modal>
  );
};

EnablePullCommunityChatModal.propTypes = {
  locals: PropTypes.object,
};

export default EnablePullCommunityChatModal;
